export default __webpack_public_path__ + "5795170556ee6c0a8d9e5b12a8ac5c5f.svg";